<p-dialog header="Сброс пароля" [(visible)]="visible" [modal]="true" [maximizable]="true" (onHide)="closeDialog()"
[style]="{width: '400px'}">
    <div class="card p-fluid">
        
        <div class="field">
            <label for="passwd">Новый пароль</label>
            <input pInputText type="text" [(ngModel)]="newPasswd" id="passwd">
        </div>

        <div class="pt-4" style="color: var(--red-300);">
            Внимание! Сохраните пароль для дальнейшего использования!
        </div>

        <div class="flex justify-end flex-wrap mt-6">
            <p-button label="Сбросить пароль" icon="pi pi-unlock" (click)="resetPasswd()"/>
        </div>
    </div>
</p-dialog>